import React from 'react';
import ReactDOM from 'react-dom';
import styles from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng-fe/errorBoundary';

class ChipView extends React.PureComponent {
    render() {
        const chipView = (
            <div className={styles.content_list}>
                <Chip id="261111" type="struct" title="分享相关数据" groupName="分享相关数据">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="289185" type="recommend" title="第一集" groupName="第一集">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="289186" type="recommend" title="第二集" groupName="第二集">
                    <div className={styles.chip_item} />
                </Chip>
                <Chip id="289187" type="recommend" title="第三集" groupName="第三集">
                    <div className={styles.chip_item} />
                </Chip>
            </div>
        );

        return ReactDOM.createPortal(chipView, document.body);
    }
}

export default errorBoundary(ChipView);
